import Req, { OpsBackend } from "./request";

import Config, { GetEnv } from "../utils/config";
import Auth from "../utils/auth";

import { getSmsType } from "../page/localStorage";

// function OrderOpsFetch(action, params, getResult, adminAction) {
// 	return Req({
// 		method: "post",
// 		baseURL: "",
// 		url: Config.UsmsOpsAPI[GetEnv()],
// 		timeout: 60000,
// 		data: {
// 			Action: action,
//       AdminAction: adminAction,
// 			SMSCategory: getSmsType() || "Text",
// 			...params
// 		},
// 		headers: { remote_user: Auth.getLocalAuthName() }
// 	}).then(res => {
// 		return getResult ? getResult(res) : res;
// 	});
// }

function OrderFetch(action, params, getResult) {
	return Req({
		method: "post",
		url: Config.OpsAPI[GetEnv()],
		timeout: 60000,
		data: {
			Action: action,
			SMSCategory: getSmsType() || "Text",
			Backend: OpsBackend.OrderBackend,
			...params
		},
		headers: { remote_user: Auth.getLocalAuthName() }
	}).then(res => {
		return getResult ? getResult(res) : res;
	});
}

export const GetCustomerPaidConfigList = params => {
	return OrderFetch("GetCustomerPaidConfigList", params)
}

export const GetBillIdList = params => {
	return OrderFetch("GetBillIdList", params)
}

export const GetPriceProductInfos = params => {
	return OrderFetch("GetPriceProductInfos", params)
}

export const GetDefaultPaidConfigList = params => {
	return OrderFetch("GetDefaultPaidConfigList", params)
}

export const SetCommonAccountDiscount = params => {
	return OrderFetch("SetCommonAccountDiscount", params)
}

export const BatchCreateCustomerPaidConfig = params => {
	return OrderFetch("BatchCreateCustomerPaidConfig", params)
}

export const CreateDefaultCustomerPaidConfig = params => {
	return OrderFetch("CreateDefaultCustomerPaidConfig", params)
}

export const BatchSetAccountDiscount = params => {
	return OrderFetch("BatchSetAccountDiscount", params)
}

export const AddAgentUserBalance = params => {
	return OrderFetch("AddAgentUserBalance", params)
}

// 获取代理商列表
export const GetAgentList = params => {
	return OrderFetch('GetAgentList', params)
}

// 代理商关联用户
export const GetAgentUser = params => {
	return OrderFetch('GetAgentUser', params)
}

// 获取代理商关联的用户列表
export const AddAgentUser = params => {
	return OrderFetch('AddAgentUser', params)
}

// 获取钱包充值流水列表
export const GetWalletUserTransaction = params => {
	return OrderFetch('GetWalletUserTransaction', params)
}

// 钱包充值
export const ConfirmWalletTransaction = params => {
	return OrderFetch('ConfirmWalletTransaction', params)
}